/*
 All keys should be declared external for bundling (esbuild)
 Only keys with values should be explicitly loaded and set on the window via requirejs in tb-main.ts
 The value is the name the package will be set under on the window object:
 For example: 'react' => window.React
*/
const externals = {
    react: 'React',
    'react-dom': 'ReactDOM',
    lodash: '_',
    zepto: 'zepto',
    experiment: 'experiment',
    // The value doesn't matter in this case, we just need requirejs to treat experiment-amd as "already loaded",
    // Otherwise, it will throw an error upon usage
    'experiment-amd': 'experimentAmd',
    color: 'color',
    '@wix/santa-components': 'santa-components',
    'create-react-class': 'create-react-class',
    'prop-types': 'prop-types',
    'pm-rpc': 'pmrpc',
    xss: 'xss',
    SoundManager: 'SoundManager',
    'data-capsule': 'data-capsule',
    '@wix/santa-core-utils': 'santa-core-utils',
    immutable: 'immutable',
    '@wix/js-platform-apps-configuration/build/platform-apps-editor': 'js-platform-apps-configuration-editor',
    '@wix/platform-editor-sdk/lib/platformEvents.min': 'platformEvents',
    '@wix/platform-editor-sdk/lib/platform-api.min': 'platformAPI',
    '@wix/santa-browser-detection': null,
    '@wix/santa-image-utils': null,
    '@wix/wix-dom-sanitizer': null,
    requirejs: null,
    runExp: null,
    '@wix/dm-ajv': '@wix/dm-ajv',
    '@wix/dm-ajv-6': '@wix/dm-ajv-6'
}

export function externalsForBundling() {
    return Object.keys(externals)
}

// Return an object mapping from package name to the name it will be set under on the window object
/** @returns {Record<string, string>} An object mapping from package name to the name it will be set under on the window object */
export function externalsForRjsMapping() {
    const relevantEntries = Object.entries(externals).filter(([, v]) => !!v)
    // @ts-expect-error - Null values were filtered out in the previous line, so this is correct
    return Object.fromEntries(relevantEntries)
}
